import React, { useCallback } from 'react';
import Box from '@quintoandar/cozy-core/Box';
import Typography from '@quintoandar/cozy-core/Typography';
import Form from '@quintoandar/cozy-core/Form';
import Input from '@quintoandar/cozy-core/Input';
import Tooltip from '@quintoandar/cozy-core/Tooltip';
import IconButton from '@quintoandar/cozy-core/IconButton';
import Delete from '@quintoandar/cozy-icons/Delete';
import {
  makeSelectVideoUrl,
  makeSelectVideoId,
} from 'containers/Video/selectors';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { changeBottomButtonPayloadAction, changeEnabledButtonAction } from 'containers/AnnouncementSteps/actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import messages from './messages';
import {
  saveVideoLinkAction,
  deleteVideoLinkAction,
} from '../../containers/Video/action';
import { YOUTUBE_BASE_LONG_URL, YOUTUBE_BASE_SHORT_URL } from './constants';

export const VideoTextInput = ({
  saveVideoLink,
  deleteVideoLink,
  changeEnabledButton,
  videoUrl,
  videoId,
  intl,
  changeBottomButtonPayload,
  houseType,
  houseId,
}) => {
  const onVideoLinkChange = useCallback((event) => {
    saveVideoLink(event.target.value);
    changeBottomButtonPayload({
      houseType,
      houseId,
      url: event.target.value,
      videoSource: 'YOUTUBE',
    });
  }, [houseType, houseId]);

  const onDeleteClick = useCallback(() => {
    deleteVideoLink(videoId);
    changeEnabledButton(true);
  }, [videoId]);

  return (
    <>
      <Box mt={4}>
        <Typography level="bodyStrong">
          <FormattedMessage {...messages.InputLinkTitle} />
        </Typography>
      </Box>
      <Box display="flex">
        <Box width="100%">
          <Form>
            <Input
              inputProps={{ 'data-testid': 'video-input' }}
              name="videoLink"
              value={videoUrl}
              autoComplete="off"
              onChange={onVideoLinkChange}
              validators={[{
                rule: (value) => [YOUTUBE_BASE_LONG_URL, YOUTUBE_BASE_SHORT_URL]
                  .some((item) => value.includes(item)),
                message: intl.formatMessage(messages.ErrorYouTubeMessage),
              }]}
              disabled={!!videoId}
            />
          </Form>
        </Box>
        <Box mt={1} ml={1}>
          <Tooltip title={intl.formatMessage(messages.DeleteAlertMessage)} variant="off" >
            <IconButton
              onClick={onDeleteClick}
              variant="destructive"
              disabled={!videoId}
              size="large"
              icon={Delete}
            />
          </Tooltip>
        </Box>
      </Box>
    </>
  );
};

export const mapDispatchToProps = (dispatch) => ({
  saveVideoLink: (url) => dispatch(saveVideoLinkAction(url)),
  deleteVideoLink: (id) => dispatch(deleteVideoLinkAction(id)),
  changeEnabledButton: (enabledButton) => dispatch(changeEnabledButtonAction(enabledButton)),
  changeBottomButtonPayload: (payload) => dispatch(changeBottomButtonPayloadAction(payload)),
});

VideoTextInput.propTypes = {
  saveVideoLink: PropTypes.func,
  deleteVideoLink: PropTypes.func,
  changeEnabledButton: PropTypes.func,
  videoUrl: PropTypes.string,
  videoId: PropTypes.string,
  intl: PropTypes.object,
  changeBottomButtonPayload: PropTypes.func,
  houseType: PropTypes.string,
  houseId: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  videoUrl: makeSelectVideoUrl(),
  videoId: makeSelectVideoId(),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  injectIntl,
  withConnect,
)(VideoTextInput);
